import { api } from "roboflex-thalamus-request-handler";
import { sso } from "roboflex-thalamus-sso-lib";

export default {

    labelsReunioes: [
        {
            label: 'Nr',
            chave: 'id',
        },
        {
            label: 'Setor',
            chave: 'setor',
        },
        {
            label: 'Data / Hora',
            chave: 'data',
            type: 'dataHora',
        },
        {
            label: 'Tipo',
            chave: 'tipo',
        },
        {
            label: 'Assunto',
            chave: 'assunto',
        },
        // {
        //     label: 'Status',
        //     chave: 'status',
        // },
        {
            label: 'Responsável',
            chave: 'responsavel',
        },
    ],
    labelsTemas: [
        {
            label: 'Nr',
            chave: 'id',
        },
        {
            label: 'Data Final',
            chave: 'dataFim',
        },
        {
            label: 'Tema',
            chave: 'descricao',
        },
        // {
        //     label: 'Status',
        //     chave: 'status',
        // },
    ],

    async baixarRelatorio() {
        api.post(`relatorio/reunioes`, {
            gerar: "xlsx"
        }, {
            responseType: 'arraybuffer',
        })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `Relatório_Reunião.xlsx`; 0,

                    document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
            })
            .catch((error) => {
                if (process.env.NODE_ENV !== 'production') console.error(error);
            });
    },

    async getUsuarios() {
        try {
            const responseUsuarios = await api.get(`usuario`);
            const usuarios = responseUsuarios.data.map(item => ({
                id: item.id,
                nome: item.name,
            }));

            return usuarios;
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error;
        }
    },

    async getTipos() {
        try {
            const response = await api.get(`/reuniao/tipo`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getReuniões(qtPorPagina, page) {
        try {
            var response = await api.get(`reuniao?page=${page}&per_page=${qtPorPagina}`)
            const dados = response.data.data
            const dadosPaginacao = response.data.meta
            dados?.sort((a, b) => b?.id - a?.id)
            return { data: dados, labels: this.labelsReunioes, paginacao: dadosPaginacao }
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async gravarReunião(payload) {
        try {
            const response = await api.post(`reuniao`, payload)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async atualizarReunião(id, payload) {
        try {
            const response = await api.post(`reuniao/${id}`, payload)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    getUsuario() {
        const usuarioSSO = sso.getUsuarioLogado();
        return {
            id: usuarioSSO?.id,
            nome: usuarioSSO?.nome,
        }
    },
    async buscarReunião(id) {
        if (id === 'criar') {
            var novaReunião = {
                hora: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
                data: new Date().toISOString().split('T')[0],
                responsavel: this.getUsuario(),
                setores: [],
                pautas: [],
                anexos: [],
            }
            return novaReunião
        } else {
            try {
                const response = await api.get(`reuniao/${id}`)
                return response.data
            } catch (error) {
                if (process.env.NODE_ENV !== 'production') console.error(error);
                throw error
            }
        }
    },
    async excluirReunião(id) {
        try {
            const response = await api.delete(`reuniao/${id}`)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async getTemas() {
        try {
            var response = await api.get(`reuniao/tema`)
            response.data?.sort((a, b) => b?.id - a?.id)
            return { data: response.data, labels: this.labelsTemas }
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async gravarTema(payload) {
        try {
            const response = await api.post(`reuniao/tema`, payload)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async buscarTema(id) {
        if (id === 'criar') {
            return {
                setores: [],
                tipos: [],
                pautas: [],
                anexos: [],
            }
        } else {
            try {
                const response = await api.get(`reuniao/tema/${id}`)
                return response.data
            } catch (error) {
                if (process.env.NODE_ENV !== 'production') console.error(error);
                throw error
            }
        }
    },
    async atualizarTema(id, payload) {
        try {
            const response = await api.post(`reuniao/tema/${id}`, payload)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async excluirTema(id) {
        try {
            const response = await api.delete(`reuniao/tema/${id}`)
            return response
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },
    async buscarPautaTemporarias(payload) {
        try {
            const response = await api.post(`reuniao/tema/pautasAnexos`, payload)
            return this.unificarResponse(response.data)
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error);
            throw error
        }
    },

    unificarResponse(response) {
        const mergeUniqueById = (array, key = "id") => {
            const map = new Map();
            array.forEach(item => map.set(item[key], item));
            return Array.from(map.values());
        };

        const setores = mergeUniqueById(response.flatMap(item => item.setores));
        const pautas = mergeUniqueById(response.flatMap(item => item.pautas));
        const anexos = mergeUniqueById(response.flatMap(item => item.anexos));

        return { setores, pautas, anexos };
    }
}